export const EdiConfiguration = {
  textFieldSuperText: 'text-right! text-[14px]! font-medium! text-[#000000]',
  tabsSpacing: '*:pb-[12px]!',
  saveIcon: 'w-[16px]!',
};

export const FeaturedFlagClasses = {
  containerClass: 'mt-4!',
  loaderStyle: 'flex! items-center! justify-center!',
};
